<template>
  <div name="stdapplinf-detail-pg6">
    <div class="row">
      <div class="col-md-12">
        <div class="card-ui clearfix border-top-color-skin">
          <div class="sub-topic-box clearfix" style="cursor: auto;">
            <div class="sub-topic">{{ labels['20'] }}</div>
          </div>

          <div class="data-box clearfix">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['30'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.namfathr }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['35'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.numofidf }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['40'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codfnatn }} - {{ data.desc_codfnatn }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['50'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codfrelg }} - {{ data.desc_codfrelg }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['60'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codfoccu }} - {{ data.desc_codfoccu }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card-ui clearfix border-top-color-skin">
          <div class="sub-topic-box clearfix" style="cursor: auto;">
            <div class="sub-topic">{{ labels['70'] }}</div>
          </div>

          <div class="data-box clearfix">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['80'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.nammothr }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['85'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.numofidm }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['90'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codmnatn }} - {{ data.desc_codmnatn }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['100'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codmrelg }} - {{ data.desc_codmrelg }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['110'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codmoccu }} - {{ data.desc_codmoccu }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card-ui clearfix border-top-color-skin">
          <div class="sub-topic-box clearfix" style="cursor: auto;">
            <div class="sub-topic">{{ labels['120'] }}</div>
          </div>

          <div class="data-box clearfix">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['130'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.namspous }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['140'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.numoffid }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['150'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codspocc }} - {{ data.desc_codspocc }}</div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['160'] }}</label>
                  <div class="form-control readonly-field-color">{{ setDateOutput(data.dtespbd) }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['170'] }}</label>
	                <textarea class="form-control"
	                          :value="data.desnoffi"
	                          readonly />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'stdapplinf-detail-pg6',
  props: [ 'labels', 'data' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg6.vue?379e0f1e